module.exports = __webpack_public_path__ + "static/img/fbtLogo1.513e6aaf.png";